import { useCallback } from 'react';
import { requestFromPriceFromSite } from '@ff-os/pdp-shared-redux/global-state/site-pricing';
import { IDT } from '@ff-os/pdp-shared-redux/IDT';
import { useExternalRender } from './useExternalRender';

export const useExternalFromPriceRender = (priceRequest: IDT.FromPriceRequest | undefined) => {
    return useExternalRender(useCallback(async () => {
        return priceRequest ? await requestFromPriceFromSite(priceRequest) : '';
    }, [priceRequest]));
};